module.exports = __webpack_public_path__ + "static/media/sky.b0974fa5.png";